import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import AppUtil from "utilities/AppUtil";
import httpRequest from "../../services/httpRequest";
import snakecaseKeys from "snakecase-keys";
// Main URL Endpoint
const _urlPrefix = "/rate";


export const fetchListRate = createAsyncThunk(
  "rate/fetchListRate",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchListRateByBookingId = createAsyncThunk(
  "rate/fetchListRateByBookingId",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/list`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchRateDetail = createAsyncThunk(
  "rate/fetchRateDetail",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/detail/${id}`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceCreateRate = createAsyncThunk(
  "rate/reduceCreateRate",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}`,
      method: "POST",
      data: snakecaseKeys(params),
      successMessage: "toast.create.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceUpdateRate = createAsyncThunk(
  "rate/reduceUpdateRate",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/update/${id}`,
      method: "PUT",
      data: snakecaseKeys(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceDeleteRate = createAsyncThunk(
  "rate/reduceDeleteRate",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/delete`,
      method: "DELETE",
      data: params,
      successMessage: "toast.remove.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceCalculatePrice = createAsyncThunk(
  "worker/reduceCalculatePrice",
  async (params) => {
      // console.log(params);
      const result = await httpRequest({
          url: `${_urlPrefix}/calculate-price`,
          data: AppUtil.toSnakeCaseKey(params),
          method: "POST"
      });
      if (!result) {
          return;
      }
      return result.data;
  }
);

export const reduceCalculatePriceSingleBooking = createAsyncThunk(
  "worker/reduceCalculatePriceSingleBooking",
  async (params) => {
      // console.log(params);
      const result = await httpRequest({
          url: `${_urlPrefix}/calculate-price-to-booking-job`,
          data: AppUtil.toSnakeCaseKey(params),
          method: "POST"
      });
      if (!result) {
          return;
      }
      return result.data;
  }
);

const initialState = {
  list: [],
  detail: {},
  calculatedPrice: {},
  activeTab: 0
};

const rate = createSlice({
  name: "rate",
  initialState: initialState,
  reducers: {
    toggleTabs: (layout, action) => {
      layout.activeTab = action.payload;
    }
  },
  extraReducers: {
    [fetchRateDetail.fulfilled]: (state, action) => {
      if (action.payload) {
        state.detail = action.payload;
        for (const key in state.detail) {
          if (!state.detail[key]) {
            state.detail[key] = '';
          }
        }
      }
    },
    [fetchListRate.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.list = payload.content;
      }
    },
    [reduceCalculatePrice.fulfilled]: (state, {payload}) => {
      if (payload) {
          state.calculatedPrice = payload;
      }
  }
  }
});

const { reducer, actions } = rate;
export const { toggleTabs } = actions;
export default reducer;

export const getRateDetail = createSelector(
  (state) => state.rate.detail,
  (user) => user
);
export const getRateList = createSelector(
  state => state.rate.list,
  list => list
);
export const getActiveTab = createSelector(
  state => state.rate.activeTab,
  activeTab => activeTab
);
